const handleDeleteDocumentFileFormService = {
  confirm: 'Deseja realmente deletar esse arquivo?',
  title: 'DELETAR ARQUIVO'
};

export default handleDeleteDocumentFileFormService;
